module.exports = __webpack_public_path__ + "static/URA-award-all-ebadb54bace50a72f582827d450cc4de.svg";